import React  from "react";
import { useParams } from 'react-router-dom';
import ReportViewItems from "./components/ReportViewItems";

const ViewReport = () => {
	const { reportId } = useParams();
    
	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<ReportViewItems recordId={reportId} mode="view"/>
	      </div>
	    </div>
    );
};

export default ViewReport;